<template>
  <div>
     <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>
       <a-card class="all-card-style " >
   <!--      搜索模块-->
      <div class="search-box">
        <a-form layout="inline">

          <a-form-item
            label="名称" class="ant-form-item2"
          >
            <a-input
              placeholder="请输入名称"
            >
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="submit" >
              查询
            </a-button>
          </a-form-item>
           <a-form-item>
            <a-button type="primary" html-type="submit" >
              导出
            </a-button>
          </a-form-item>
           <a-form-item>
            <a-button type="primary" html-type="submit" >
              打印
            </a-button>
          </a-form-item>
        </a-form>
      </div>
      <!-- 搜索 -->

       <!--      列表表格-->

            <div style="margin-top:20px;">
               <a-button type="primary" html-type="submit" @click="goToNewAdd">
              +新建
            </a-button>
              <a-table   :columns="columns" :data-source="data" style="margin-top:20px;">
          <span slot="action" slot-scope="text, record">
           <div> <a>删除</a> <a @click="goToNewAdd">修改</a> </div>
          </span>


              </a-table>
            </div>
      <!-- 列表 -->
       </a-card>
  </div>
</template>
<script>
import TitleCard from '@/components/TitleCard.vue'
export default {
   name: 'logList',
        components: {
            TitleCard
        },
  data(){
    return{
       titleMsg1:"生产管理",
                titleMsg2:'员工信息管理',
                titleMsg3:'员工信息管理',
      data,
      columns
    }
  },
  methods:{
   goToNewAdd:function(){
     this.$router.push({path:'/productionmanagement/employeemanagement/EmployeeManagementNewAdd'})
   }
  }
}
 const columns = [

    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      className:'column-money'
    },
    {
      title: '手机号',
      dataIndex: 'placename',
      key: 'placename',
      className:'column-money'
    },
    {
      title: '性别',
      dataIndex: 'workcontent',
      key: 'workcontent',
      className:'column-money'
    },
    {
      title: '生日',
      dataIndex: 'workstatus',
      key: 'workstatus  ',
      className:'column-money'
    },
    {
      title: '创建时间',
      dataIndex: 'starttime',
      key: 'starttime',
      className:'column-money'
    },
    {
      title: '修改时间',
       dataIndex: 'endtime',
      key: 'endtime',
      className:'column-money'

    },

     {
      title: '操作',
      dataIndex: 'num',
      key: 'num',
      className:'column-money',
      scopedSlots: { customRender: 'action' },
    },
  ];

  const data = [
    {
      key: '1',
      name:'害虫防治',
      placename:'大棚',
      workcontent:'浇水',
      workstatus:'未派发',
      starttime:'2016-09-21',
      endtime:'2016-09-21',
      sendtime:'2016-09-21',
      finishtime:'2016-09-21'
    },
    {
      key: '2',
     name:'害虫防治',
      placename:'大棚',
      workcontent:'浇水',
      workstatus:'未派发',
      starttime:'2016-09-21',
      endtime:'2016-09-21',
      sendtime:'2016-09-21',
      finishtime:'2016-09-21'
    },
    {
      key: '3',
      name:'害虫防治',
      placename:'大棚',
      workcontent:'浇水',
      workstatus:'未派发',
      starttime:'2016-09-21',
      endtime:'2016-09-21',
      sendtime:'2016-09-21',
      finishtime:'2016-09-21'
      },

    {
      key: '4',
     name:'害虫防治',
      placename:'大棚',
      workcontent:'浇水',
      workstatus:'未派发',
      starttime:'2016-09-21',
      endtime:'2016-09-21',
      sendtime:'2016-09-21',
      finishtime:'2016-09-21'
    },

    {
      key: '5',
     name:'害虫防治',
      placename:'大棚',
      workcontent:'浇水',
      workstatus:'未派发',
      starttime:'2016-09-21',
      endtime:'2016-09-21',
      sendtime:'2016-09-21',
      finishtime:'2016-09-21'
    },
  ];
</script>
